<div class="task-tag-selector-popup-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-icon" aria-hidden="true">
      <mat-icon>label</mat-icon>
    </div>
    <div class="header-content">
      <h2 class="dialog-title">Add Tags</h2>
    </div>
    <button class="close-btn" (click)="close()" type="button" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content">
    <!-- Search Existing Tags -->
    <!-- <div class="search-section">
    <ng-select
      [items]="tagSearchResults$ | async"
      bindLabel="name"
      placeholder="Search tags..."
      [searchable]="true"
      [clearable]="true"
      [loading]="tagSearchLoading"
      [typeahead]="tagSearchInput$"
      (change)="selectTag($event)"
      class="tag-search-select">

      <ng-template ng-option-tmp let-item="item">
        <div class="tag-option" [class.tag-disabled]="isTagSelected(item)">
          <div class="tag-chip-preview"
            [style.background-color]="getColorStyle(item.color)['background-color']"
            [style.color]="getColorStyle(item.color)['color']">
            <span>{{ item.name }}</span>
          </div>
          <mat-icon *ngIf="isTagSelected(item)" class="check-icon">check_circle</mat-icon>
        </div>
      </ng-template>

      <ng-template ng-notfound-tmp>
        <div class="no-results">
          <mat-icon>label_off</mat-icon>
          <span>No tags found</span>
        </div>
      </ng-template>
    </ng-select>
  </div> -->

  <!-- Popular Tags -->
  <!-- <div class="popular-tags-section" *ngIf="existingTags.length > 0">
  <h3>Popular Tags</h3>
  <div class="tags-grid">
    <button
      *ngFor="let tag of existingTags.slice(0, 12)"
      type="button"
      class="tag-option-btn"
      [class.tag-selected]="isTagSelected(tag)"
      [disabled]="isTagSelected(tag)"
      (click)="selectTag(tag)">
      <span class="tag-color-dot"
      [style.background-color]="getColorStyle(tag.color)['background-color']"></span>
      <span class="tag-name">{{ tag.name }}</span>
      <mat-icon *ngIf="isTagSelected(tag)" class="check-icon">check_circle</mat-icon>
    </button>
  </div>
</div> -->

<!-- Create New Tag -->
<div class="create-new-section">
  <!-- <button
  type="button"
  class="create-new-toggle"
  (click)="toggleCreateNew()">
  <mat-icon>{{ showCreateNew ? 'expand_less' : 'add' }}</mat-icon>
  <span>{{ showCreateNew ? 'Cancel' : 'Create New Tag' }}</span>
</button> -->

@if (showCreateNew) {
  <div class="create-new-form">
    <input type="text" class="tag-name-input" [value]="newTagName" (input)="newTagName = $any($event.target).value"
      placeholder="Enter tag name..." maxlength="30">
    <div class="color-selector">
      <label>Color:</label>
      <div class="color-options">
        @for (color of availableColors; track color) {
          <button type="button" class="color-option"
            [class.selected]="newTagColor === color.key" [style.background-color]="color.bg"
            [style.color]="color.text" (click)="selectPreset(color.key)"
            [attr.aria-label]="'Select ' + color.name + ' color'">
            @if (newTagColor === color.key) {
              <mat-icon>check</mat-icon>
            }
          </button>
        }

        <!-- Custom colour. The label wraps the input so clicking the swatch
             opens the browser's native colour picker. -->
        <label class="color-option color-option-custom"
          [class.selected]="isHex(newTagColor)"
          [style.background-color]="customColor"
          [attr.aria-label]="'Choose a custom color'">
          <input type="color" class="native-color-input"
            [value]="customColor"
            (input)="onCustomColorChange($any($event.target).value)">
          @if (isHex(newTagColor)) {
            <mat-icon>check</mat-icon>
          } @else {
            <mat-icon>palette</mat-icon>
          }
        </label>
      </div>
    </div>
    <div class="tag-preview">
      <span>Preview:</span>
      <div class="tag-chip" [ngStyle]="getColorStyle(newTagColor)">
        {{ newTagName || 'Tag Name' }}
      </div>
    </div>
  </div>
}
</div>
</div>

<!-- Dialog Footer -->
@if (showCreateNew) {
  <div class="dialog-footer">
    <button class="btn-cancel" (click)="close()">
      <mat-icon>close</mat-icon>
      Cancel
    </button>
    <button class="btn-submit" (click)="createNewTag()" [disabled]="!newTagName.trim()">
      <mat-icon>check_circle</mat-icon>
      Create & Add Tag
    </button>
  </div>
}
</div>